import { render } from "./changeSociete.vue?vue&type=template&id=4960adf2"
import script from "./changeSociete.vue?vue&type=script&lang=ts"
export * from "./changeSociete.vue?vue&type=script&lang=ts"

import "./changeSociete.vue?vue&type=style&index=0&id=4960adf2&lang=css"
script.render = render

export default script